const COMPONENT_TYPE_NAV = "nav";
const COMPONENT_TYPE_UI = "ui";
const COSTCO_TRAVEL = "Costco Travel";
const TRACK_TYPE_NAVIGATION = "navigation";
const TRACK_TYPE_SEARCH = "search";
const TRACK_TYPE_AD = "ad";
const TRACK_TYPE_MULTI_ATTR = "multiAttribute";
const TRACK_TYPE_OBJECT = "object";
const TRACK_TYPE_SOCIAL_SHARE = "social-share";
const TRACK_TYPE_PDP_WHY_BUY = "why-buy";
const TRACK_TYPE_PDP_FULFILLMENT = "fulfillment";
const TRACK_TYPE_PDP_ADD_TO_CART = "pdp-add-to-cart";
const TRACK_TYPE_PDP_PRODUCT_PRICE_CARD = "product-price-button";
const TRACK_TYPE_PDP_PRODUCT_ACTION = "product-action-button";
const TRACK_TYPE_PDP_ACCORDION = "pdp-accordion";
const TRACK_TYPE_EXTERNAL_LINK = "ext-link-visit";
const TRACK_TYPE_PRODUCT_NOT_AVAILABLE = "product-not-available";
const TRACK_TYPE_ATC_CONTINUE_SHOPPING = "atc-continueShopping";
const TRACK_TYPE_ATC_VIEW_CART = "atc-viewCart";
const TRACK_TYPE_VIEW = "view";
const ESPOT = "espot";
const SEARCH_TYPE = "searchType";
const SEARCH_TYPE_TYPED = "typed";
const SEARCH_TYPE_MARKETING = "Marketing Search";
const SEARCH_TYPE_TYPEAHEAD = "typeahead";
const SEARCH_IDENTIFIER_SEARCHBARSEARCH = "searchTerm";
const SEARCH_IDENTIFIER_WHSEARCH = "whSearchTerm";
const ONE = "1";
const SEARCHBAR_SEARCH = "search";
const WHSEARCH = "whSearch";
const WHSEARCH_LOC = "whSearchLoc";
const WHSEARCH_NO_SEARCHTERM = "(No Search Term Entered)";
const ITEM_TYPE_AD = "ad";
const ITEM_TYPE_PRODUCT = "product";
const ITEM_TYPE_CATEGORY = "category";
const PARAM_KEYWORD = "keyword";
const EXTERNAL_IDENTIFIER = "ext";
const NOT_APPLICABLE = "na";
const SAVE_TO_LIST = "saveToList";
const SEPARATOR_PIPE = " | ";
const SEPARATOR_COLON = ":";
const SEPARATOR_SEMICOLON = ";";
const SEPARATOR_SPACE = " ";
const URL_PATTERN_PDP = /\.product\.(\d+)\.html/;
const URL_PATTERN_SEARCH = /(\/CatalogSearch|\/s).*keyword=/;
const COOKIE_DEBUG_ANALYTICS = "debugAnalytics";
const FILTER = "filter";
const FILTER_VAL = "filterVal";
const FILTER_REMOVE = "filterRemove";
const FILTER_ACTION_ADD = "add";
const FILTER_ACTION_REMOVE = "remove";
const KEY_CART_ADD = "cartAdd";
const KEY_PRODUCTS = "products";
const KEY_PID = "pid";
const KEY_SEARCH_CLICK = "searchClick";
const KEY_PRODUCT_CLICK = "productClick";
const CATEGORY_PAGE_TYPE = "category";
const KEY_SKU = "sku";
const DIGITALDATA_PAGE_NAME_HOMEPAGE = "Home";
const PAGE_NAME_HOMEPAGE = "homepage";
export {
  CATEGORY_PAGE_TYPE,
  COMPONENT_TYPE_NAV,
  COMPONENT_TYPE_UI,
  COOKIE_DEBUG_ANALYTICS,
  COSTCO_TRAVEL,
  DIGITALDATA_PAGE_NAME_HOMEPAGE,
  ESPOT,
  EXTERNAL_IDENTIFIER,
  FILTER,
  FILTER_ACTION_ADD,
  FILTER_ACTION_REMOVE,
  FILTER_REMOVE,
  FILTER_VAL,
  ITEM_TYPE_AD,
  ITEM_TYPE_CATEGORY,
  ITEM_TYPE_PRODUCT,
  KEY_CART_ADD,
  KEY_PID,
  KEY_PRODUCTS,
  KEY_PRODUCT_CLICK,
  KEY_SEARCH_CLICK,
  KEY_SKU,
  NOT_APPLICABLE,
  ONE,
  PAGE_NAME_HOMEPAGE,
  PARAM_KEYWORD,
  SAVE_TO_LIST,
  SEARCHBAR_SEARCH,
  SEARCH_IDENTIFIER_SEARCHBARSEARCH,
  SEARCH_IDENTIFIER_WHSEARCH,
  SEARCH_TYPE,
  SEARCH_TYPE_MARKETING,
  SEARCH_TYPE_TYPEAHEAD,
  SEARCH_TYPE_TYPED,
  SEPARATOR_COLON,
  SEPARATOR_PIPE,
  SEPARATOR_SEMICOLON,
  SEPARATOR_SPACE,
  TRACK_TYPE_AD,
  TRACK_TYPE_ATC_CONTINUE_SHOPPING,
  TRACK_TYPE_ATC_VIEW_CART,
  TRACK_TYPE_EXTERNAL_LINK,
  TRACK_TYPE_MULTI_ATTR,
  TRACK_TYPE_NAVIGATION,
  TRACK_TYPE_OBJECT,
  TRACK_TYPE_PDP_ACCORDION,
  TRACK_TYPE_PDP_ADD_TO_CART,
  TRACK_TYPE_PDP_FULFILLMENT,
  TRACK_TYPE_PDP_PRODUCT_ACTION,
  TRACK_TYPE_PDP_PRODUCT_PRICE_CARD,
  TRACK_TYPE_PDP_WHY_BUY,
  TRACK_TYPE_PRODUCT_NOT_AVAILABLE,
  TRACK_TYPE_SEARCH,
  TRACK_TYPE_SOCIAL_SHARE,
  TRACK_TYPE_VIEW,
  URL_PATTERN_PDP,
  URL_PATTERN_SEARCH,
  WHSEARCH,
  WHSEARCH_LOC,
  WHSEARCH_NO_SEARCHTERM
};
